import { render, staticRenderFns } from "./DocumentConsolidation.vue?vue&type=template&id=79c74534&scoped=true"
import script from "./DocumentConsolidation.vue?vue&type=script&lang=js"
export * from "./DocumentConsolidation.vue?vue&type=script&lang=js"
import style0 from "./DocumentConsolidation.vue?vue&type=style&index=0&id=79c74534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c74534",
  null
  
)

export default component.exports